/// <reference path='../_all.ts' />

module user {
  'use strict';

  export class LoginData {
    constructor(
      public email: string,
      public password: boolean,
      public persist: boolean,
      public showLogin: boolean
      ) { }
  }
}